import React, { useEffect } from 'react';
import { Button, FormControl, Grid } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import PageUtils from '../../utils/pageUtils';
import { FormattedMessage } from 'react-intl';
import LanguageUtils from '../../utils/LanguageUtils';
import Action from '../../interfaces/common/action';
import ProductArenaFilters from '../../interfaces/filters/productArenaFilters';
import { fetchProductArenaTypes, getProductArenaTypes } from '../../reducers/productArenaTypeReducer';
import { fetchUnitGroups, getUnitGroups } from '../../reducers/unitGroupReducer';
import ProductArenaType from '../../interfaces/output/productArenaType';
import UnitGroup from '../../interfaces/output/unitGroup';
import ActionRenderer from '../common/actionRenderer';
import GenericTextField from '../common/widgets/genericTextField';
import GenericAutocomplete from '../common/widgets/genericAutocomplete';

interface IFilterProps {
    filters: ProductArenaFilters;
    onChange: any;
    applyFilters: any;
    setDefaultState: any;
    actions?: Array<Action>;
}

const messages = {
    name: LanguageUtils.createMessage('Name'),
    productArenaType: LanguageUtils.createMessage('Product Arena Type'),
    unitGroup: LanguageUtils.createMessage('Unit Group'),
    resetFilters: LanguageUtils.createMessage('Reset filters'),
    applyFilters: LanguageUtils.createMessage('Apply filters')
};

export default function ProductArenaFilterComponent(props: IFilterProps): JSX.Element {
    const { filters, onChange, applyFilters, setDefaultState, actions } = props;
    const paging = PageUtils.getMaxPaging();
    const dispatch = useDispatch();
    const productArenaTypes = useSelector(getProductArenaTypes).content;
    const unitGroups = useSelector(getUnitGroups).content;

    useEffect(() => {
        dispatch(fetchProductArenaTypes({ paging }));
        dispatch(fetchUnitGroups({ paging }));
    }, [dispatch]);

    return (
        <Grid container p={2} direction="column">
            <Grid item>
                <Grid container spacing={2} mt={1} justifyContent="flex-end">
                    <ActionRenderer actions={actions} />
                </Grid>
            </Grid>
            <Grid item xs>
                <Grid container spacing={2} alignItems="flex-end">
                    <Grid item xs>
                        <FormControl fullWidth>
                            <GenericTextField<string>
                                name="searchTerm"
                                label={messages.name}
                                onChange={onChange}
                                value={filters.searchTerm}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs>
                        <GenericAutocomplete<ProductArenaType>
                            options={productArenaTypes}
                            value={filters.productArenaTypeId}
                            onChange={(obj: ProductArenaType | null) => onChange('productArenaTypeId', obj?.id)}
                            placeholder={messages.productArenaType}
                            compareFn={(o: ProductArenaType) => o.id === filters.productArenaTypeId}
                            getOptionLabel={(option: ProductArenaType) => option.nameNo}
                        />
                    </Grid>
                    <Grid item xs>
                        <GenericAutocomplete<UnitGroup>
                            options={unitGroups}
                            value={filters.unitGroupId}
                            onChange={(obj: UnitGroup | null) => onChange('unitGroupId', obj?.id)}
                            placeholder={messages.unitGroup}
                            compareFn={(o: UnitGroup) => o.id === filters.unitGroupId}
                        />
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid container spacing={2} mt={1} justifyContent="flex-end">
                        <Grid item>
                            <Button onClick={setDefaultState}><FormattedMessage {...messages.resetFilters} /></Button>
                        </Grid>
                        <Grid item>
                            <Button onClick={applyFilters}><FormattedMessage {...messages.applyFilters} /></Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}